import { apiClient } from './client'

export type Effet = 'morph' | 'fade' | 'slide'

export type CarouselPhoto = {
  id: number
  marque: string
  src: string
  ordre: number
  visible: boolean
  uploaded: boolean
}

export type CarouselConfig = {
  marque: string
  effet: Effet
  vitesse_ms: number
}

export type CarouselData = {
  config: CarouselConfig
  photos: CarouselPhoto[]
}

export async function getCarousel(marque: string): Promise<CarouselData> {
  const { data } = await apiClient.get<CarouselData>(`/api/carousel/${marque}`)
  return data
}

// ── Admin ──

export async function adminGetCarousel(marque: string): Promise<CarouselData> {
  const { data } = await apiClient.get<CarouselData>(`/api/carousel/${marque}/admin`)
  return data
}

export async function updateCarouselConfig(
  marque: string,
  cfg: { effet?: Effet; vitesse_ms?: number },
): Promise<void> {
  await apiClient.put(`/api/carousel/${marque}/config`, cfg)
}

export async function uploadCarouselPhoto(marque: string, file: File): Promise<void> {
  const form = new FormData()
  form.append('file', file)
  await apiClient.post(`/api/carousel/${marque}/photos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export async function updateCarouselPhoto(
  id: number,
  patch: { visible?: boolean; ordre?: number },
): Promise<void> {
  await apiClient.put(`/api/carousel/photos/${id}`, patch)
}

export async function reorderCarousel(marque: string, ids: number[]): Promise<void> {
  await apiClient.put(`/api/carousel/${marque}/reorder`, { ids })
}

export async function deleteCarouselPhoto(id: number): Promise<void> {
  await apiClient.delete(`/api/carousel/photos/${id}`)
}
